import React from 'react';

/**
 * Small, discreet disclaimer shown at the bottom of every public-facing
 * page (login, register, forgot-password, waitlist, waitlist-status).
 *
 * The brand name "Government Shield" reads as authoritative by design —
 * this disclaimer makes the sovereignty stance explicit and preempts any
 * app-store or trademark review concerns about perceived government
 * affiliation. Rendered as plain slate text so it's always present but
 * never competes visually with the primary CTA.
 */
export const GovernmentDisclaimer = ({ className = '' }) => (
  <p
    className={`text-center text-[11px] text-slate-600 leading-relaxed ${className}`}
    data-testid="government-disclaimer"
  >
    Government Shield is an independent project and
    <br className="sm:hidden" />{' '}
    <span className="text-slate-400">
      will never be affiliated with any government.
    </span>
  </p>
);

export default GovernmentDisclaimer;
